import GlobalFlagshipNav from "../../components/flagship/GlobalFlagshipNav";
import Header from "../../components/header/Header";
import LearnMoreBox from "../../components/learn-more/LearnMoreBox";
import NavLearnMore from "../../components/learn-more/NavLearnMore";
import "./index.css";
import "./top.css";

export default function LearnMore () {
    return (
        <>
            <Header sectionIn />

            <div className="p-index">
                <main>

                    <div class="o-box__nav_flagship is-mb_type1">
                        <GlobalFlagshipNav />
                    </div>

                    <div className="o-box__nav_flagship is-top_sp">
                        <ul className="g-nav_flagship" data-reactroot="">
                            <li><a href="/alpineflagship">Product Information</a></li>
                            <li><a href="/alpineflagship/aprendemas">Tech / Features</a></li>
                            <li><a href="/alpineflagship/producto/">Spec List</a></li>
                        </ul>
                    </div>

                    <NavLearnMore />
                    <LearnMoreBox />

                    <div class="o-single_img__lm_thumb is-mt_type1">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb1_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb1_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="o-single_img__lm_thumb">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb2_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb2_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb3_sp.png')} alt="" />
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">
                            <p>(Fig. 5) Además de la frecuencia fundamental o primer armónico, los armónicos a frecuencias más altas producen un sonido característico de cada instrumento musical, como el violín. Los armónicos de alta frecuencia pueden llegar más allá del rango de frecuencias audibles por el oído humano.</p>
                            <p>Si los armónicos de alta frecuencia son eliminados simplemente porque los sonidos en ese rango son inaudibles al oído humano (Fig. 6), el sonido característico se debilitará y los sonidos reproducidos del instrumento musical pueden distar del original.</p>
                            <p>Una fuente de sonido de alta resolución puede reproducir frecuencias más allá del rango audible por los humanos, y por consiguiente puede recrear los sonidos del instrumento musical original. Especialmente los sonidos en los rangos de alta frecuencia son más expresivos, haciendo los sonidos más delicados y profundos. Ante todo, el gran beneficio del alta resolución son los brillantes sonidos de alta frecuencia con muy poca distorsión y características sonoras realistas.</p>
                        </div>
                    </div>

                    <div class="o-single_img__lm_thumb is-mt_type1">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb4_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb3_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb5_sp.png')} alt="" />
                    </div>

                    <div class="l-main__learn_more_box">
                        <a name="perfect" class="anchor"></a>
                        <h2 id="perfect" class="o-title__bk_band is-l_us2">
                            <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/learn_more_title2_sp.png')} />
                                <img src={require('../../images/alpineflagship/lm/learn_more_title2_pc.png')} alt="" />
                            </picture>
                        </h2>
                        
                        <div class="o-single_img__perfect_logo">
                            <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/perfect_logo_sp.png')} />
                                <img src={require('../../images/alpineflagship/lm/perfect_logo_pc.png')} alt="PERFECT SYNCHRONIZATION" />
                            </picture>
                        </div>
                
                        <h3 id="lm3" class="o-title__learn_more_sub">Sobre la distorsión por fluctuación</h3>
                
                        <div class="o-text_box__base is-font_type1">
                            <p>Debido al limitado espacio de instalación en un vehículo, es necesario separar la unidad principal que reproduce y controla la fuente de sonido del procesador de audio que realiza el ajuste de sonido dentro del sistema. Tradicionalmente, estas señales digitales eran procesadas individualmente por cada uno de los relojes de los componentes del sistema, pero esto causaba desviaciones y problemas de sincronización en las señales digitales, llamada “jitter” (errores de reloj). Esta desviación (distorsión por fluctuación) causaba que los detalles de la música se pierdan. Para lograr la reproducción de alta resolución con las especificaciones más altas de 384 kHZ/32 bits, el impacto negativo del jitter debía ser tratado. El Alpine F#1 Status creó el Sistema de Administración Master Clock que sincroniza completamente la transmisión entre la unidad principal y el procesador de audio con un único “reloj maestro”. Incorporando esto al sistema, el Alpine F#1 Status eliminó casi completamente el jitter en la transmisión de audio..</p>
                        </div>
                    </div>

                    <div class="o-single_img__lm_thumb is-mt_type1">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb6_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb4_pc.png')} alt="" />
                        </picture>
                        <div class="o-text_box__base is-font_type1">
                            <p>Para sistemas convencionales: Reloj; Unidad principal; Procesador de audio; Por más que sea digital, hay un leve desalineamiento de señales (distorsión por fluctuación); Frecuencia; Tiempo; Desalineamiento de señales (distorsión por fluctuación); Unidad Principal; Procesador de audio; Error convencional de alrededor del 0,1%</p>
                            <p>El sistema de administración Master Clock: Unidad principal; Sincroniza con reloj interno; Señales de sincronización; Procesador de audio; El reloj maestro; Frecuencia; Tiempo; Unidad principal; Procesador de audio; Sincroniza; Hasta 10.000 veces más preciso; Logra el 0,00001[%]</p>
                        </div>
                    </div>


                    <div class="l-main__learn_more_box">

                        <h3 id="lm4" class="o-title__learn_more_sub is-mt_type1">Sobre el cristal con la más alta precisión</h3>

                        <div class="o-text_box__base is-font_type1">
                            <p>Como el oscilador de cristal se encuentra en el centro del Sistema de Administración Master Clock, sin necesidad de decirlo, la precisión es su esencia. El oscilador de cristal, llamado OCXO DuCULoN®*1, es el centro del procesador de audio, que es el dispositivo principal de ajuste del vehículo, y está protegido de la influencia del ruido y los cambios de temperatura. Dos cristales de cuarzo están insertados en una caja especializada y aislada térmicamente junto con un circuito de control de temperatura, el cual permite tener una precisión 500 veces mejor que el de un oscilador de cristal estándar. Para reducir el ancho de fluctuación del 0,002%, causado por los cambios de temperatura, a casi el 0% para estabilizar el oscilador, el oscilador es calentado cuando se enciende el suministro eléctrico. Una vez que la temperatura del oscilador llega al nivel donde la precisión del reloj se estabiliza, la luz del indicador se enciende y la temperatura se mantiene constante.</p>
                            <p>DuCULoN® es una marca registrada de NIHON DEMPA KOGYO Co., Ltd.</p>
                        </div>

                    </div>

                    <div class="o-single_img__lm_thumb is-mt_type2">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb7_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb5_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb8_sp.png')} alt="" />
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb9_sp.png')} alt="" />
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb10_sp.png')} alt="" />
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">
                            <p><b>Interior del procesador de audio</b></p>
                            <p>Reloj maestro “OCXO DuCULoN®”: Dos cristales de gran tamaño son utilizados para lograr una compensación mutua y la más alta precisión. </p>
                            <p>Ancho de fluctuación temporal; Precisión temporal (ancho de desviación); Productos existentes estándar; Precisión 500 veces mayor</p>
                            <p>El rendimiento cambia debido al cambio de la temperatura de operación del cristal; Calentado hasta que se llega al punto de estabilización; Ancho de fluctuación f0 (ruido de fase); Temperatura de operación</p>
                        </div>
                    </div>



                    <div class="l-main__learn_more_box">

                        <h3 id="lm5" class="o-title__learn_more_sub is-mt_type2">Sobre la compensación del tiempo de llegada</h3>

                        <div class="o-text_box__base is-font_type1">
                            <p>Mientras que la precisión y el rendimiento son factores importantes a considerar en un sistema, tener un sistema de altavoces apropiado determinará la calidad final del sonido, así que es necesario realizar un ajuste altamente preciso para asegurar la calidad del sonido de alta resolución. Dentro del vehículo, el sonido llega en momentos diferentes al oyente debido a la diferencia en la posición de instalación entre los altavoces de alta, media y baja frecuencia para el mismo canal y la distancia asimétrica del asiento del conductor a los altavoces derechos e izquierdos. La función del procesador de audio es hacer la corrección de tiempo del sonido para el oyente. Cuando se trata de sonido de alta resolución con altas especificaciones, es vital que los altavoces estén ajustados de manera precisa. El diagrama de abajo muestra un caso en el cual la diferencia en el tiempo entre el altavoz izquierdo y derecho es grande o pequeña.  El espacio en la distancia causa que las ondas sonoras de ambos altavoces se cancelen uno al otro y producir distorsión, lo cual afecta mucho la calidad de sonido. Mientras que en los productos tradicionales el ancho se puede ajustar solamente a pasos de 7,2ms (a una temperatura ambiente de 20°C), el procesador de audio del Alpine F#1 Status puede ajustar a pasos de 0,9mm, ocho veces más ajustado que los productos tradicionales. Como es probable que el oyente note la diferencia de tiempo, especialmente en los rangos de alta frecuencia presentes en los sonidos de alta resolución, la capacidad de un ajuste mínimo como esto es crucial en el espacio interior del automóvil. Para lograr un ajuste más preciso de sonido, el Alpine F#1 Status ha incorporado cuatro unidades del procesador de sonido digital de mejor calidad (DSPs), capacitado con un poder de procesamiento de 64 bit/1 GHz. Este procesador tiene una capacidad diez veces mayor que los modelos tradicionales, permitiendo procesar señales de alta resolución y alta especificación, sin perder detalles del sonido.</p>
                        </div>

                    </div>

                    <div class="o-single_img__lm_thumb is-mt_type1">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb11_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb6_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">        
                            <p>Compensación de la diferencia de distancia entre los altavoces: Diferencia temporal entre unidades; Diferencia temporal entre derecha e izquierda
        Con compensación de tiempo/Sin compensación de tiempo: Cuando se reproduce sonido con 10kHz; Forma de onda sintetizada; Altavoz 1; Altavoz 2</p>
                        </div>
                    </div>

                    <div class="o-single_img__lm_thumb">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb12_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb7_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">        
                            <p>Corrección de tiempo; Productos convencionales: la distancia es ajustada en pasos de 7,2mm; Una precisión ocho veces mayor comparada a modelos convencionales; Corrección de tiempo ultra preciso con pasos de 0,9mm; La especificación más alta para dispositivos a bordo 0,9mm corresponde a un ángulo de instalación de aproximadamente 1 grado [en un automóvil] Altavoz 1; Altavoz 2; 1 grado</p>
                        </div>
                    </div>

                    <div class="o-single_img__lm_thumb">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb13_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb8_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb14_sp.png')} alt="" />
                    </div>

                    <div class="l-main__learn_more_box">

                        <h3 id="lm6" class="o-title__learn_more_sub is-mt_type3">La razón por la cual se utilizó CFRP</h3>
                
                        <div class="o-text_box__base is-font_type1">
                            <p>Los altavoces tradicionales están hechos con materiales optimizados y una estructura adecuada para un ancho de banda de reproducción específica. Si se reduce el espesor y el peso del diafragma, se vuelve óptimo para la reproducción de audio de alta frecuencia, pero también tendrá menos rigidez. Si el diafragma es grueso y rígido, se vuelve óptimo para la reproducción de audio de baja frecuencia. El desafío durante el proceso de producción de los altavoces fue seleccionar materiales que complementen las características de los altavoces, pero que a su vez superen las desventajas durante la reproducción. En otras palabras, el material del altavoz impactaba directamente al sonido durante la reproducción. Para vencer esta cuestión, el Alpine F#1 Status intentó unificar los tonos de los altavoces igualando los materiales y sus estructuras. Luego de infinitas pruebas y errores, el mejor resultado se obtuvo utilizando Plásticos Reforzados con Fibra de Carbono (CFRP). Con un material ligero pero altamente rígido, el CFRP es usado como el diafragma de los altavoces, desde los tweeters de frecuencias ultra altas hasta los subwoofers de bajas frecuencias. Esta es la primera vez en la industria del audio para automóvil que se usa un material común para todos los altavoces del sistema.</p>
                        </div>

                    </div>

                    <div class="o-single_img__lm_thumb is-mt_type3">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb15_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb9_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">  
                            <p><b>Diferencias en el tono y las características del material del diafragma</b></p>
                            <p>Para sonidos de alta frecuencia: se prioriza la reducción de peso. Para sonidos de baja frecuencia: se prioriza la alta rigidez.</p>
                            <p><b>Materiales diferentes producen tonos diferentes.</b></p>
                            <p>Material, Peso específico, Tensión de rotura (MPa), Módulo de flexión (GPa); CFRP de fibra continua; Aluminio (material general); Magnesio; Hierro; Resina (PP); Resina (PP + mica) (material general)</p>
                        </div>
                    </div>
                    
                    <div class="o-single_img__lm_thumb">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb16_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb10_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">  
                            <p>CFRP de fibra continua; Desplazamiento: 1; PP + mica; Desplazamiento: 11,65<br/>
                            Figura: Comparación relativa del desplazamiento cuando el diafragma es presionado con cierta carga; El CFRP es altamente rígido y difícil de deformarse.<br/>
Ejemplo de un caso de instalación y una ilustración de la superposición; El ancho de banda superpuesto es amplio.
</p>
                        </div>
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb17_sp.png')} alt="" />
                    </div>

                    <div class="o-single_img__lm_thumb is-to_mq">
                        <img src={require('../../images/alpineflagship/lm/lm_thumb18_sp.png')} alt="" />
                    </div>

                    <div class="l-main__learn_more_box">
                        <a name="lm7" class="anchor"></a>
                        <h2 id="lm7" class="o-title__bk_band is-l_us3 is-mt_type2">
                            <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/learn_more_title3_sp.png')} />
                                <img src={require('../../images/alpineflagship/lm/learn_more_title3_pc.png')} alt="" />
                            </picture>
                        </h2>
                        
                
                        <h3 class="o-title__learn_more_sub">Qué es especial del amplificador operacional</h3>
                
                        <div class="o-text_box__base is-font_type1">
                            <p>El dispositivo clave para mejorar la performance y la calidad de sonido de un procesador de audio es un amplificador operacional. En la búsqueda inflexible del sonido del Alpine F#1 Status, nosotros seleccionamos MUSES05*2, el cual se enorgullece de la mejor performance de la industria, y nuestro maestro del sonido ha producido una calidad de sonido supremo. Notamos el cambio en la calidad de sonido causado por cambios mínimos de la corriente en el circuito interno, y la influencia de las ondas armónicas en el ancho de banda de varios MHz. Mejoramos la pureza del procesamiento de señales cambiando la estructura estándar de dos circuitos por chip a un solo circuito por chip. Este cambio aisló los circuitos de cada amplificador y eliminó completamente la interferencia mutua, entregando una calidad de sonido clara y nítida en el ancho de banda audible.</p>
                            <p>*2: MUSES es una marca registrada de New Japan Radio Co., Ltd.</p>
                        </div>

                    </div>

                    <div class="o-single_img__lm_thumb is-thumb19">
                        <picture>
                            <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/lm_thumb19_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/lm_thumb11_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="o-box__bottom_care">
                        <picture>
                        <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/lm/reference_sp.png')} />
                            <img src={require('../../images/alpineflagship/lm/reference_pc.png')} alt="" />
                        </picture>
                    </div>

                    <div class="l-main__learn_more_box">
                        <div class="o-text_box__base is-font_type1">  
                            <p>Imagen del interior del MUSES05 <br />
                            Amplificador operacional estándar<br />
                            Amplificador operacional MUSES desarrollado recientemente</p>
                        </div>
                    </div>

                    


                    <div className="o-box__nav_learn_more is-bottom_nav">
                        <NavLearnMore />
                    </div>

                    <div class="o-box__nav_flagship is-mt_type2">
                        <GlobalFlagshipNav />
                    </div>

                </main>

                <div class="p-index__footer is-mt_type1">
                    <picture>
                    <source type="image/png" media="(max-width:767px)" srcset={require('../../images/alpineflagship/copyright_sp.png')} />
                        <img src={require('../../images/alpineflagship/copyright_pc.png')} alt="copyright" />
                    </picture>
                </div>
            </div>

        </>
    );
}